var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.service.pricingSourceType === 'PRIVATE')?_c('div',{staticClass:"accent--text"},[_vm._v("\n    "+_vm._s(_vm.$t(`pricingSourceType.${_vm.service.pricingSourceType}`))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }